import { render, staticRenderFns } from "./RemesasPersonalTable.vue?vue&type=template&id=93d1fe50"
import script from "./RemesasPersonalTable.vue?vue&type=script&lang=js"
export * from "./RemesasPersonalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports